import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  primaryAction?: { label: string; to?: string; onClick?: () => void };
  hideTitle?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, primaryAction, hideTitle }) => {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between mb-3">
      <div>
        {hideTitle ? null : title ? (
          <h1 className="mb-0 font-bold text-lg text-slate-700 dark:text-slate-200 capitalize">{title}</h1>
        ) : null}
        {subtitle ? (
          <p className={`text-[11px] leading-normal text-slate-500 dark:text-slate-400 ${hideTitle ? '' : 'mt-1'}`}>
            {subtitle}
          </p>
        ) : null}
      </div>
      {primaryAction ? (
        primaryAction.onClick ? (
          <Button variant="primary" onClick={primaryAction.onClick}>
            {primaryAction.label}
          </Button>
        ) : primaryAction.to ? (
          <Link to={primaryAction.to}>
            <Button variant="primary">{primaryAction.label}</Button>
          </Link>
        ) : null
      ) : null}
    </div>
  );
};

export default PageHeader;

